import { z } from "zod/v4";

export const profileCountriesSchema = z.array(z.object({
  cc2: z.string().regex(/^[A-Z]{2}$/), name: z.string(), flag: z.string(),
}));
export const profileCurrenciesSchema = z.array(z.object({
  code: z.string().regex(/^[A-Z]{3}$/), name: z.string(), flag: z.string().nullable(),
}));
export type PreferenceOption = { value: string; label: string; flag: string | null };

/** Match Expo's regional-indicator flags; never infer a flag from a currency/language code. */
export function preferenceFlag(value: string | null): string | null {
  const flag = value?.trim() ?? "";
  return /^[\u{1F1E6}-\u{1F1FF}]{2}$/u.test(flag) ? flag : null;
}

/** Retain the server value while a catalogue loads/fails, without guessing or rewriting it. */
export function preferenceOptions(entries: PreferenceOption[], current: string | null): PreferenceOption[] {
  const options = new Map(entries.map((entry) => [entry.value, { ...entry, flag: preferenceFlag(entry.flag) }]));
  if (current && !options.has(current)) options.set(current, { value: current, label: current, flag: null });
  return [...options.values()];
}
